export default "__VITE_ASSET__C68uLgiG__"